import type { TFunction } from "@/i18n/catalog";

/**
 * The service-time dimension stored on `waste_events.service_time`. Mirrored on the backend in
 * `backend/app/schemas/waste.py` (`ServiceTime`), which is a closed four-value literal.
 */
export const SERVICE_TIMES = ["breakfast", "lunch", "dinner", "unassigned"] as const;

/**
 * Literal keys in a lookup table, never a key assembled at runtime — `check-i18n.mjs` resolves
 * keys statically, so a built key is invisible to it (POS2-1134).
 *
 * This map was written out four times across the waste surface as an English `Record` before it
 * moved here, which is how one of them drifts. `/labelling/workstation` keeps its own English copy
 * by pinned decision 4, the same arrangement `lib/waste-types.ts` has.
 */
const SERVICE_TIME_LABEL_KEYS: Record<string, string> = {
  breakfast: "reference.serviceTime.breakfast",
  lunch: "reference.serviceTime.lunch",
  dinner: "reference.serviceTime.dinner",
  unassigned: "reference.serviceTime.unassigned",
};

export function serviceTimeLabel(t: TFunction, key: string): string {
  const labelKey = SERVICE_TIME_LABEL_KEYS[key];
  return labelKey ? t(labelKey) : key;
}
